import styled from 'styled-components';
import GreenMultiTickSvg from '../../assets/settings/green-multi-tick.svg';

const GreenMultiTickIcon = styled(GreenMultiTickSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '1.7rem'};
height: ${props => props.height || '1.7rem'};
margin: ${props => props.margin};
fill: ${props => props.fill};
`;

export default GreenMultiTickIcon;
